import { EventEmitter } from "events";

class MyEmitter extends EventEmitter {}

export default new MyEmitter();
